import React from 'react';
import PropTypes from 'prop-types';

import BusComponent from '../../BusComponent';
import LegendLayout from '../../../enums/LegendLayout';

import MultiShadedAreaLegendDetailed from './MultiShadedAreaDetailed';
import MultiShadedAreaLegendSimplified from './MultiShadedAreaSimplified';
import SingleShadedAreaLegendSimplified from './SingleShadedAreaSimplified';
import SingleShadedAreaLegendDetailed from './SingleShadedAreaDetailed';

class ShadedAreaLegend extends BusComponent {
    render() {

        const { mapInstance, layout, libraryLegendInfo, dataDictionaryInfo } = this.props;

        if (mapInstance.dataTheme.variableSelection.isMultiVariable) {
            if (layout === LegendLayout.DETAILED) {
                return (
                    <MultiShadedAreaLegendDetailed
                        mapInstance={mapInstance}
                        renderer={mapInstance.dataTheme.rendering[0]}
                        libraryLegendInfo={libraryLegendInfo}
                    />
                );
            }
            return (
                <MultiShadedAreaLegendSimplified
                    mapInstance={mapInstance}
                    renderer={mapInstance.dataTheme.rendering[0]}
                    variables={dataDictionaryInfo.variables}
                />
            );
        }
        if (layout === LegendLayout.DETAILED) {
            return (
                <SingleShadedAreaLegendDetailed
                    renderer={mapInstance.dataTheme.rendering[0]}
                    mapInstance={mapInstance}
                />
            );
        }
        return (
            <SingleShadedAreaLegendSimplified
                mapInstance={mapInstance}
                renderer={mapInstance.dataTheme.rendering[0]}
            />
        );
    }
}

ShadedAreaLegend.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    dataDictionaryInfo: PropTypes.object.isRequired,
    libraryLegendInfo: PropTypes.array,
    layout: PropTypes.string,
};

ShadedAreaLegend.defaultProps = {
    libraryLegendInfo: undefined,
};

export default ShadedAreaLegend;
